import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IJSONAPIErrorCodes, IStatus } from "shared/types";
import { DeleteModal } from "shared/components";
import { copy } from "shared/assets";

import { dataMetaSelector } from "Bands/state";
import { EventBlocks, IEventBlock } from "Bands/types";
import { useClearActionMetaOnUnMount } from "Bands/utils";

const deleteCopy = copy.eventBlock.delete;
const guestlistCopy = copy.guestlistBlock.delete.messages;

interface DeleteEventBlockModalProps {
  block: IEventBlock;
  handleClose: () => void;
}

export const DeleteEventBlockModal: React.FC<DeleteEventBlockModalProps> = ({
  block: { id, title, deleteAction, handleDelete, type },
  handleClose,
}) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(dataMetaSelector(deleteAction));

  useClearActionMetaOnUnMount(deleteAction);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      handleClose();

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteCopy.messages.success.replace("%title", title),
        })
      );
    }
  }, [dispatch, apiMeta, handleClose, title]);

  const onSubmit = () => {
    dispatch(handleDelete(id));
  };

  const error = useMemo(() => {
    if (!apiMeta?.error) return false;

    const { errorCodes } = apiMeta?.error;

    if (
      type === EventBlocks.guestlist &&
      errorCodes.includes(IJSONAPIErrorCodes.HasDistributedTickets)
    ) {
      return guestlistCopy.guestsAdded;
    }

    return !!apiMeta?.error;
  }, [apiMeta?.error, type]);

  return (
    <DeleteModal
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={onSubmit}
      name={title}
      error={error}
      type="block"
    ></DeleteModal>
  );
};
